import { FC } from 'react'

import classNames from 'classnames'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types.ts'

import s from './styles.module.scss'

interface StarRatingProps {
  rating: number
  maxStars?: number
  size?: number
  className?: string
  filledIcon?: AllIcons
}

export const StarRating: FC<StarRatingProps> = ({
  rating,
  maxStars = 5,
  size = 18,
  className,
  filledIcon = AllIcons.STAR_FILLED,
}) => {
  return (
    <div className={classNames(s.wrapper, className)}>
      {Array.from({ length: maxStars }).map((_, index) => (
        <AppIcon
          key={index}
          id={index < rating ? filledIcon : AllIcons.STAR_OUTLINE}
          width={size}
          height={size}
          className={s.star}
        />
      ))}
    </div>
  )
}
